import { render } from "./file-excel.svg?vue&type=template&id=8a87ea38?inline"
const script = {}
script.render = render

export default script